<script>
  import { Route } from "svelte-routing";
  import { authStore } from "../authStore";
  import AccessDenied from "./AccessDenied.svelte";

  export let path;
  export let component;
  export let isBusinessRoute = false; // Default to false
  export let isAdminRoute = false;    // Default to false

  let canAccess = false;
  
  // Reactively check permissions whenever the auth state changes
  $: {
    const user = $authStore.user;
    const isBusiness = $authStore.isBusiness;
    const isAdmin = $authStore.isAdmin;

    if (!user) {
      canAccess = false; // Not logged in, no access
    } else if (isBusinessRoute && !isBusiness) {
      canAccess = false; // Logged in, but not a business user on a business route
    } else if (isAdminRoute && !isAdmin) {
      canAccess = false; // Logged in, but not an admin on an admin route
    } else {
      canAccess = true; // Logged in and has the required permission
    }
  }
</script>

<Route {path} let:params>
  {#if canAccess}
    <!-- If access is granted, render the actual page component -->
    <svelte:component this={component} {...params} />
  {:else}
    <!-- If access is denied, render the AccessDenied message -->
    <AccessDenied />
  {/if}
</Route>
